import React from 'react';
import { Link } from 'react-router-dom';
import { Clapperboard, PlusCircle, Play, ShieldCheck, ExternalLink } from 'lucide-react';

// Bannière de lancement « Shorts » — version courte fournie par l'utilisateur
export default function ShortsAnnounceBanner() {
  return (
    <section className="max-w-7xl mx-auto px-4 lg:px-6 mt-10" data-testid="shorts-announce-banner">
      <div className="relative overflow-hidden rounded-3xl border border-sky-500/30 bg-gradient-to-br from-[#07131d] via-[#0a0a0b] to-[#160a0b] p-6 sm:p-8">
        <div className="absolute -top-16 -right-16 w-64 h-64 rounded-full bg-sky-600/10 blur-3xl pointer-events-none" />
        <div className="absolute -bottom-20 -left-10 w-64 h-64 rounded-full bg-red-600/10 blur-3xl pointer-events-none" />
        <div className="relative flex flex-col lg:flex-row lg:items-center gap-6">
          <div className="flex-1 min-w-0">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-sky-500/15 border border-sky-400/40 text-sky-300 text-[10.5px] font-bold uppercase tracking-[0.2em] font-mono-spec mb-3">
              <Clapperboard size={12} /> Nouveau · Communauté
            </div>
            <h2 className="font-serif-editorial text-white text-[24px] sm:text-[30px] leading-tight">
              Vos vidéos. Vos astuces. <span className="text-sky-300">Notre communauté.</span>
            </h2>
            <p className="text-white/65 text-[13.5px] sm:text-[14px] mt-2 leading-relaxed max-w-2xl">
              Les Shorts arrivent sur CodeVoiture.fr et Code2Roues.fr ! Proposez vos vidéos sur la conduite auto ou moto
              et partagez ce qui vous aide à progresser : un créneau réussi, un giratoire bien abordé, une erreur à éviter…
            </p>
            <p className="text-white/40 text-[11.5px] mt-2 inline-flex items-center gap-1.5">
              <ShieldCheck size={12} className="text-emerald-400" /> Proposition soumise à validation avant publication.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row lg:flex-col gap-2.5 shrink-0">
            <Link to="/shorts/proposer" data-testid="announce-propose-cta"
              className="h-11 px-5 rounded-full bg-gradient-to-r from-sky-500 to-sky-700 hover:from-sky-400 hover:to-sky-600 text-white text-[13px] font-bold inline-flex items-center justify-center gap-2 shadow-lg shadow-sky-900/40 transition active:scale-95">
              <PlusCircle size={15} /> Proposer ma vidéo
            </Link>
            <Link to="/shorts" data-testid="announce-shorts-cta"
              className="h-11 px-5 rounded-full border border-white/20 text-white/90 hover:bg-white/5 text-[13px] font-semibold inline-flex items-center justify-center gap-2 transition">
              <Play size={14} /> Voir les Shorts
            </Link>
            <a href="https://code2roues.fr" target="_blank" rel="noopener noreferrer" data-testid="announce-code2roues"
              className="text-center text-sky-300/80 hover:text-sky-200 text-[11.5px] font-semibold inline-flex items-center justify-center gap-1">
              Côté moto : Code2Roues.fr <ExternalLink size={11} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
